import {createSlice} from '@reduxjs/toolkit';
import {RootState} from "../../app/store";

export interface AuthState {
    loggedIn: boolean;
    username: string;
    token?: string;
}

const initialState: AuthState = {
    loggedIn: true,
    username: '-',
};


export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state) => {
            state.loggedIn = true;
        },
        logout: (state) => {
            state.loggedIn = false;
        },
    }
});


export const { login, logout } = authSlice.actions;


export const selectLoggedIn = (state: RootState) => state.auth.loggedIn;

export default authSlice.reducer;